<template>
  <div class="footer">
    <div class="waveWrapper waveAnimation">
      <div class="waveWrapperInner bgTop">
        <div class="wave waveTop"></div>
      </div>
      <div class="waveWrapperInner bgMiddle">
        <div class="wave waveMiddle"></div>
      </div>
      <div class="waveWrapperInner bgBottom">
        <div class="wave waveBottom"></div>
      </div>
    </div>
    <div class="foot">
      <!-- <div class="nav">
        <a href="">首页</a>|
        <a href="/aboutPark">主题乐园</a>|
        <a href="/show">精彩演艺</a>|
        <a href="https://www.fangte.com/activities/" target="_blank">精彩活动</a>|
        <a href="/FareInform">游客服务</a>|
        <a href="https://www.fantawild.com/" target="_blank">网上预订</a>|
        <a href="https://www.fantawild.com/" target="_blank">华强方特</a>|
        <a href="https://www.hqftdm.com/" target="_blank">方特动漫</a>
      </div> -->
      <div class="tip tip1">
        <span>版权所有：华强方特（深圳）智能技术有限公司 <a target="_blank" href="http://www.fangte.com/jyxkz.html" title="增值电信业务营业许可证">《增值电信业务营业许可证》</a> </span>
        <span>许可证编号：粤B2-20090023</span>
      </div>
      <div class="tip">
        <span>ICP备案号：<a target="_blank" href="https://beian.miit.gov.cn/" title="ICP备案号">粤ICP备05131581号-3</a>文网文【2009】</span>
        <span>038号&nbsp;&nbsp;<a target="_blank" href="https://www.fangte.com/images/certificate/shiting.pdf" title="信息网络传播视听节目许可证">信息网络传播视听节目许可证</a>AVSP1910586号</span>
      </div>
    </div>
  </div>

</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  height: 426px;
  .foot {
    width: 1400px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 226px;
    transform: translate(-50%, 0);
    font-size: 24px;
    color: #fff;
    z-index: 20;
  }
  .nav {
    display: flex;
    justify-content: space-between;
  }
  a {
    cursor: pointer;
  }
  .tip {
    text-align: left;
    margin-top: 30px;
    span:last-child {
      float: right;
    }
  }
  .tip1 {
    margin-top: 40px;
  }
}
@keyframes move_wave {
  0% {
    transform: translateX(0) translateZ(0) scaleY(1);
  }
  50% {
    transform: translateX(-25%) translateZ(0) scaleY(0.9);
  }
  100% {
    transform: translateX(-50%) translateZ(0) scaleY(1);
  }
}
.waveWrapper {
  overflow: hidden;
  position: relative;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
  height: 100%;
}
.waveWrapperInner {
  position: absolute;
  width: 100%;
  overflow: hidden;
  bottom: 0;
}
.bgTop {
  z-index: 15;
  height: 350px;
}
.bgMiddle {
  z-index: 10;
  height: 447px;
}
.bgBottom {
  z-index: 5;
  height: 412px;
}
.wave {
  position: absolute;
  left: 0;
  width: 200%;
  height: 100%;
  background-repeat: repeat-x;
  background-position: 0 bottom;
  transform-origin: center bottom;
}
.waveTop {
  background-image: url('~@/assets/wave-top.png');
}
.waveAnimation .waveTop {
  animation: move-wave 3s;
  -webkit-animation: move-wave 3s;
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
  // animation: move_wave 14s linear infinite;
  opacity: 0.8;
  background-repeat: no-repeat;
}
.waveMiddle {
  background-image: url('~@/assets/wave-mid.png');
  background-size: 1920px 450px;
}
.waveAnimation .waveMiddle {
  animation: move_wave 15s linear infinite;
}
.waveBottom {
  background-image: url('~@/assets/wave-bot.png');
  background-size: 1920px 452px;
}
.waveAnimation .waveBottom {
  animation: move_wave 20s linear infinite;
}
</style>